<template>
	<div class="pages">
		<div class="brand">{{appName}}</div>
		<div class="login">
			<div class="logo">请使用工作帐户登录</div>
		    <el-form label-position="left" label-width="80px">
		      <el-form-item label="帐户">
		        <el-input v-model="account" placeholder="请输入帐户"></el-input>
		      </el-form-item>
		      <el-form-item label="密码">
		        <el-input v-model="pwd" placeholder="请输入密码" type="password" show-password></el-input>
		      </el-form-item>
		      <el-button type="primary" round @click="login" icon="el-icon-right" :disabled="!account || !pwd">登录</el-button>
		    </el-form>
		</div>
		<div class="fainc">
			<img src="../../assets/fainc.png" class="fainc-logo">
		</div>
	</div>
    
</template>
<script>
	import storage from '@/utils/common/storage.js'
export default {
    data () {
        return {
			appName:'',
			account:'',
			pwd:''
        }
    },
	created() {
		this.appName = this.$appName
	},
	methods:{
		login(){
			
			this.$fetch.post('Account/login',{account:this.account,pwd:this.pwd},true).then(res=>{
				storage.setToken(res)
				this.$router.replace({
				    path: '/',
				 })
			})
		}
	}
}
</script>

<style scoped>
		.pages{
		
			background:url(../../assets/login-ground.jpg) top center no-repeat;
			background-size: cover;
			width: 100%;
			height: 100vh;
			display: flex;
			align-items: center;
			justify-content: center;
			flex-direction: column;
			
		}
		.login{
			width: 400px;
			background: #FFFFFF;
			padding:40px;
			border-radius: 4px;
		}
		.logo{
			padding-bottom: 40px;
			font-weight: bold;
			font-size: 18px;
			color: #333;
		}
		.brand{
			color: #FFFFFF;
			padding-bottom: 50px;
			font-size: 40px;
			font-weight: bold;
		}
		.fainc-logo{
			width: 100px;
			position: absolute;
			bottom: 50px;
			right: 50px;
		}
</style>